import "./GarageDoorMotorRepairSydney.module.css";
import Header from "@/reusable_sections/Header";
import Motorhero from "./sections/Motorhero";
import Motorintro from "./sections/Motorintro";
import Motorissues from "./sections/Motorissues";
import Motorprocess from "./sections/Motorprocess";
import Whychoosemotor from "./sections/Whychoosemotor";
import Motorpricing from "./sections/Motorpricing";
import Motorrelatedservices from "./sections/Motorrelatedservices";
import Motorfaq from "./sections/Motorfaq";
import Motorfinalcta from "./sections/Motorfinalcta";
import ServiceAreas from "./sections/ServiceAreas";
import MotorFooter from "./sections/MotorFooter";
export default function GarageDoorMotorRepairSydneyPage() {
  return <div>
      <Header />
      <Motorhero />
      <Motorintro />
      <Motorissues />
      <Motorprocess />
      <Whychoosemotor />
      <Motorpricing />
      <Motorrelatedservices />
      <Motorfaq />
      <Motorfinalcta />
      <ServiceAreas />
      <MotorFooter />
    </div>;
}